const phoneNumberLength = (value) => {
  if (!value) {
    return true;
  }
  return value.toString().replace('(', '').replace(')', '').split('-')
    .join('')
    .split(' ')
    .join('').length === 11;
};

export default phoneNumberLength;
